import { render, staticRenderFns } from "./PatientDetail.vue?vue&type=template&id=857cd0ba&scoped=true&lang=pug"
import script from "./PatientDetail.vue?vue&type=script&lang=js"
export * from "./PatientDetail.vue?vue&type=script&lang=js"
import style0 from "./PatientDetail.vue?vue&type=style&index=0&id=857cd0ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857cd0ba",
  null
  
)

export default component.exports